import React from 'react'

type Props = {
  checked: boolean
  onChange: () => void
  /** Stop click propagation (e.g. when nested inside a clickable table row). */
  stopPropagation?: boolean
  disabled?: boolean
}

export const SwitchToggle = ({ checked, onChange, stopPropagation, disabled }: Props) => (
  <label
    style={{
      position: 'relative',
      display: 'inline-block',
      width: 36,
      height: 20,
      cursor: disabled ? 'not-allowed' : 'pointer',
      flexShrink: 0,
      verticalAlign: 'middle',
      opacity: disabled ? 0.5 : 1,
    }}
    onClick={
      stopPropagation
        ? (e: React.MouseEvent) => {
            e.stopPropagation()
            e.preventDefault()
            if (!disabled) onChange()
          }
        : undefined
    }
  >
    <input
      type="checkbox"
      checked={checked}
      onChange={stopPropagation ? undefined : disabled ? undefined : onChange}
      disabled={disabled}
      style={{ opacity: 0, width: 0, height: 0, position: 'absolute' }}
    />
    <span
      style={{
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: checked ? '#22c55e' : '#cbd5e1',
        borderRadius: 10,
        transition: 'background-color 0.2s',
      }}
    />
    <span
      style={{
        position: 'absolute',
        width: 14,
        height: 14,
        left: checked ? 19 : 3,
        top: 3,
        backgroundColor: '#fff',
        borderRadius: '50%',
        transition: 'left 0.2s',
        boxShadow: '0 1px 3px rgba(0,0,0,.25)',
      }}
    />
  </label>
)



// WEBPACK FOOTER //
// ./src/app/shared/components/switch-toggle/switch-toggle.component.tsx